// extracted by mini-css-extract-plugin
module.exports = {"OEu-detail":"OEu_OEu-detail__VMsu6"};